import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { isNil, omitBy } from 'lodash-es';
import { useTheme } from '@emotion/react';
import { memo } from 'react';
import Typography from '../../Typography/index.js';
import { IconUIElement, IconContainer } from '../../../Icon/index.js';
const Link = memo(props => {
    const { children, style, transform = 'lowercase', arrowPosition, ...restProps } = props;
    const theme = useTheme();
    const customStyles = typeof style === 'function' ? style(theme) : style;
    function renderContent() {
        switch (arrowPosition) {
            case 'right':
                return (_jsxs(_Fragment, { children: [children, _jsx(IconContainer, { style: theme => ({
                                width: 20,
                                height: 7,
                                margin: '0 0 0 5px',
                                color: theme.primaryAccentColor
                            }), ariaLabel: "arrow", children: _jsx(IconUIElement.ArrowLong, {}) })] }));
            case 'left':
            default:
                return (_jsxs(_Fragment, { children: [_jsx(IconContainer, { style: theme => ({
                                width: 20,
                                height: 7,
                                margin: '0 5px 0 0',
                                color: theme.primaryAccentColor,
                                rotate: -180
                            }), ariaLabel: "arrow", children: _jsx(IconUIElement.ArrowLong, {}) }), children] }));
        }
    }
    return (_jsx(Typography, { ...restProps, style: theme => ({
            color: theme.primaryAccentColor,
            cursor: 'pointer',
            alignItems: 'center',
            textTransform: transform,
            display: arrowPosition ? 'inline-flex' : 'initial',
            transition: 'opacity 0.2s ease',
            '&:hover': {
                opacity: 0.75
            },
            ...omitBy(customStyles, v => isNil(v) || v === '')
        }), children: arrowPosition ? renderContent() : children }));
});
export default Link;
//# sourceMappingURL=index.js.map